import Typography from "typography"
import noriegaTheme from "typography-theme-noriega";

const typography = new Typography(noriegaTheme)

export default typography


// WEBPACK FOOTER //
// ./src/utils/typography.js